import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { HelpOpenerService } from '../../services/help-opener.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule],
  selector: 'ideals-help-button',
  styleUrls: ['./help-button.component.scss'],
  templateUrl: './help-button.component.html',
})
export class HelpButtonComponent {
  readonly #helpOpenerService = inject(HelpOpenerService);

  openHelpModal(event: MouseEvent): void {
    event?.preventDefault();
    this.#helpOpenerService.openHelp('recommendations');
  }
}
